<div
  class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center"
>
  <div
    class="bg-white w-[380px] xl:w-[430px] 2xl:w-[480px] min-h-[300px] xl:min-h-[340px] 2xl:min-h-[380px] max-h-[370px] xl:max-h-[415px] 2xl:max-h-[460px] overflow-hidden rounded-md xl:rounded-lg 2xl:rounded-lg flex flex-col relative 3xl:w-[600px] 3xl:min-h-[480px] 3xl:max-h-[575px] 3xl:rounded-xl"
  >
    <div class="p-3 xl:p-3.5 2xl:p-4 flex flex-col flex-1 min-h-0 3xl:p-5">
      <!-- Title -->
      <div
        class="flex items-center justify-between pb-2 xl:pb-2.5 2xl:pb-3 shrink-0 3xl:pb-4"
      >
        <h1
          class="text-[0.85rem] xl:text-[0.9rem] 2xl:text-[0.95rem] text-dimot-1 pl-1 3xl:text-[1.25rem] 3xl:pl-[5px]"
        >
          {{ widgetTitle || 'Curva di Apertura Ospedaliera*' }} - Mese
          {{ curvePointData.selectedPeriod }}
          <span
            *ngIf="periodRangeLabel"
            class="block text-gray-500 text-[0.6rem] xl:text-[0.65rem] 2xl:text-[0.7rem] 3xl:text-[0.875rem]"
          >
            {{ periodRangeLabel }}
          </span>
        </h1>
        <button class="shrink-0">
          <svg
            (click)="closeModal()"
            class="cursor-pointer w-4 h-4 xl:w-5 xl:h-5 2xl:w-[22px] 2xl:h-[22px] 3xl:w-[28px] 3xl:h-[28px]"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z"
              fill="#141F58"
            />
          </svg>
        </button>
      </div>

      <!-- Header -->
      <table class="w-full table-fixed border-collapse shrink-0">
        <colgroup>
          <col class="w-[70%]" />
          <col class="w-[30%]" />
        </colgroup>
        <thead
          [ngClass]="
            curvePointData.type == 'Actual' ? 'bg-dimot-1' : 'bg-dimot-2'
          "
        >
          <tr
            class="text-left"
            [ngClass]="
              curvePointData.type == 'Actual' ? 'text-white' : 'text-white'
            "
          >
            <th
              class="py-[12px] xl:py-[14px] 2xl:py-[16px] pl-3 xl:pl-4 2xl:pl-5 text-[0.55rem] xl:text-[0.62rem] 2xl:text-[0.7rem] rounded-tl-[3px] 2xl:rounded-tl-[4px] 3xl:py-[20px] 3xl:pl-[25px] 3xl:text-[0.875rem] 3xl:rounded-tl-[5px]"
              [ngClass]="
                curvePointData.type == 'Actual' ? 'bg-dimot-1' : 'bg-dimot-2'
              "
            >
              <h1>{{ curvePointData.type | uppercase }}</h1>
            </th>
            <th
              class="pl-1 2xl:pl-[5px] text-center text-[0.65rem] xl:text-[0.72rem] 2xl:text-[0.8rem] rounded-tr-[3px] 2xl:rounded-tr-[4px] 3xl:pl-[6px] 3xl:text-[1rem] 3xl:rounded-tr-[5px]"
              [ngClass]="
                curvePointData.type == 'Actual' ? 'bg-dimot-1' : 'bg-dimot-2'
              "
            >
              <h2>{{ curvePointData.value | number: "1.2-2" }} %</h2>
            </th>
          </tr>
        </thead>
      </table>

      <!-- Body -->
      <div class="overflow-y-auto flex-1 min-h-0 scrollbar2">
        <table class="w-full table-fixed border-collapse">
          <colgroup>
            <col class="w-[70%]" />
            <col class="w-[30%]" />
          </colgroup>
          <tbody>
            <tr
              *ngIf="isLoading"
              class="h-[190px] xl:h-[215px] 2xl:h-[240px] 3xl:h-[300px]"
            >
              <td
                class="pl-3 xl:pl-4 2xl:pl-5 py-[12px] xl:py-[14px] 2xl:py-[16px] text-dimot-1 text-[0.75rem] xl:text-[0.84rem] 2xl:text-[0.92rem] text-center 3xl:pl-[25px] 3xl:py-[20px] 3xl:text-[1.15rem]"
                colspan="2"
              >
                <div role="status">
                  <svg
                    aria-hidden="true"
                    class="inline w-8 h-8 xl:w-9 xl:h-9 2xl:w-10 2xl:h-10 text-gray-200 animate-spin dark:text-gray-600 fill-dimot-1 3xl:w-[50px] 3xl:h-[50px]"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span class="sr-only">Loading...</span>
                </div>
              </td>
            </tr>
            <tr
              *ngIf="Regioni.length === 0 && !isLoading"
              class="h-[190px] xl:h-[215px] 2xl:h-[240px] 3xl:h-[300px]"
            >
              <td class="text-center" colspan="2">
                <p
                  class="inline-block text-gray-400 font-medium text-[0.6rem] xl:text-[0.7rem] 2xl:text-[0.75rem] bg-gray-100 px-4 py-2 rounded-sm"
                >
                  Nessun dato disponibile
                </p>
              </td>
            </tr>
            <ng-container *ngFor="let regione of Regioni; let i = index">
              <!-- Region row -->
              <tr
                (click)="toggleAccordion(i)"
                class="cursor-pointer transition"
                [ngClass]="
                  activeIndexes.includes(i)
                    ? 'bg-[#F4F6F8] border-y border-gray-200'
                    : curvePointData.type == 'Actual'
                      ? 'bg-white hover:bg-blue-50'
                      : 'bg-white hover:bg-green-50'
                "
              >
                <td
                  class="pl-3 xl:pl-4 2xl:pl-5 py-[12px] xl:py-[14px] 2xl:py-[16px] text-gray-800 text-[0.6rem] xl:text-[0.67rem] 2xl:text-[0.74rem] 3xl:pl-[25px] 3xl:py-[20px] 3xl:text-[0.925rem]"
                >
                  <span>
                    {{
                      regione.regionName === "Prov. Aut. di Bolzano"
                        ? "PA di Bolzano"
                        : regione.regionName === "Prov. Aut. di Trento"
                          ? "PA di Trento"
                          : regione.regionName
                    }}
                  </span>
                </td>
                <td
                  class="pl-2 xl:pl-2.5 2xl:pl-3 py-[12px] xl:py-[14px] 2xl:py-[16px] text-center text-dimot-1 text-[0.56rem] xl:text-[0.62rem] 2xl:text-[0.68rem] flex items-center gap-2 xl:gap-2.5 2xl:gap-3 justify-center 3xl:pl-[15px] 3xl:py-[20px] 3xl:text-[0.85rem] 3xl:gap-[15px]"
                >
                  {{ regione.potentialPercentage | number: "1.2-2" }}%
                  <svg
                    data-accordion-icon
                    [ngClass]="{
                      'rotate-0': activeIndexes.includes(i),
                      'rotate-180': !activeIndexes.includes(i),
                    }"
                    class="w-[8px] h-[8px] xl:w-[9px] xl:h-[9px] 2xl:w-2.5 2xl:h-2.5 shrink-0 3xl:w-3 3xl:h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M9 5 5 1 1 5"
                    />
                  </svg>
                </td>
              </tr>

              <!-- Hospital rows -->
              <ng-container *ngIf="activeIndexes.includes(i)">
                <tr
                  *ngFor="let hospital of regione.hospitals"
                  class="border-b border-gray-100"
                >
                  <td
                    class="pl-7 xl:pl-8 2xl:pl-9 py-[12px] xl:py-[14px] 2xl:py-[16px] text-gray-800 text-[0.56rem] xl:text-[0.63rem] 2xl:text-[0.7rem] w-[70%] align-top 3xl:pl-[45px] 3xl:py-[20px] 3xl:text-[0.875rem]"
                  >
                    {{ hospital.hospitalName | hospitalTitlecase }} -
                    {{ hospital.hospitalCity | titlecase }}
                  </td>
                  <td
                    class="pl-[2px] xl:pl-[3px] 2xl:pl-1 py-[12px] xl:py-[14px] 2xl:py-[16px] text-center text-gray-800 text-[0.56rem] xl:text-[0.63rem] 2xl:text-[0.7rem] w-[30%] align-top 3xl:pl-[5px] 3xl:py-[20px] 3xl:text-[0.875rem]"
                  >
                    {{ hospital.hospitalPercentage | number: "1.2-2" }}%
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
